/* eslint-disable no-unused-expressions */

export function uploadFile(handleDataFetch) {
  return new Promise((resolve, reject) => {
    if (!window.cloudinary) {
      reject(new Error("Cloudinary not available"));
      return;
    }

    window.cloudinary.openUploadWidget(
      {
        cloudName: process.env.REACT_APP_API_CLOUDINARY_CLOUD_NAME,
        uploadPreset: process.env.REACT_APP_API_CLOUDINARY_UPLOAD_PRESET,
        sources: ["local"],
        showAdvancedOptions: false,
        cropping: false,
        multiple: false,
        clientAllowedFormats: ["png", "jpeg", "jpg", "pdf"],
        resourceType: "auto", // auto: images -> image, pdf -> raw
        singleUploadAutoClose: false,
        maxFileSize: 5242880, // 5MB
        defaultSource: "local",
        styles: {
          palette: {
            window: "#FFFFFF",
            windowBorder: "#047558",
            tabIcon: "#047558",
            menuIcons: "#047558",
            textDark: "#000000",
            textLight: "#FFFFFF",
            link: "#047558",
            action: "#047558",
            inactiveTabIcon: "#888888",
            error: "#F44235",
            inProgress: "#047558",
            complete: "#047558",
            sourceBg: "#FFFFFF",
          },
          fonts: { default: { active: true } },
        },
      },
      (error, result) => {
        if (error) {
          console.error("Upload error:", error);
          reject(error);
          return;
        }

        if (!result) {
          reject(new Error("No result returned from Cloudinary"));
          return;
        }

        if (result.event === "success" && result.info) {
          const file = result.info;
          const isPdf = file.format === "pdf";
          const fileType = isPdf ? "pdf" : "image";

          // Always use secure_url
          const fileUrl = file.secure_url;

          // Build file data
          const fileData = {
            url: fileUrl, // direct file (raw for pdf, image for images)
            preview_url: isPdf
              ? fileUrl.replace("/raw/upload/", "/image/upload/pg_1,w_200/") // thumbnail for PDFs
              : fileUrl, // images preview directly
            type: fileType,
            format: file.format,
            original_filename: file.original_filename,
          };

          handleDataFetch?.(fileData);
          resolve(fileData);
        } else if (result.event === "close" || result.event === "abort") {
          console.log("Upload cancelled by user");
        } else {
          console.log("Cloudinary widget event:", result.event);
        }
      }
    );
  });
}

